import classes from "../classes";
import LeaderboardMovement from "./leaderboard-movement";
import pure from "./higher-order/pure";
import React from "react";
import survivorBetScore from "../survivor-bet-score";
import TowelIcon from "./towel-icon";
import { FormattedScore } from "./formatted-currency";

export default pure(({ bet, number, race, raceEntrant, ticket, ticketScore, tournament }) => {
  if (race.get("status") === "open") {
    return null;
  }

  var horse = "No Pick";
  var pick = <i className="dw-warning5 dw--1-75x color--is-medium-gray" />;
  if (race.get("status") === "cancelled") {
    pick = <i className="dw-blocked dw--2x color--is-medium-gray" />;
    horse = "Race Cancelled";
  }

  var odds;
  if (bet && bet.get("race_entrant_id") === null) {
    pick = <i className="dw-star_outline dw--2x color--is-medium-gray" />;
    odds = "Favorite";
  }
  var position;
  if (raceEntrant) {
    horse = raceEntrant.get("horse_name");
    var lane = raceEntrant.get("lane_number");
    odds = raceEntrant.get("morning_line");
    pick = <TowelIcon lane={lane} small />;
    position = getPlace(lane, race.get("race_result"));
  }
  var score = <FormattedScore value={bet ? bet.get("score") : 0} />;

  if (tournament.get("tournament_type") === "Survivor") {
    score = (
      <span>
        {survivorBetScore(bet, race, number, ticket)}
      </span>
    );
  }

  var movement;
  if (ticketScore) {
    movement = <LeaderboardMovement movement={ticketScore.get("rank_change")} />;
  }

  var rank;
  if (ticketScore) {
    rank = ticketScore.get("rank");
  }

  return (
    <ul className={classes({
      "leaderboard_picks_table": true,
      "color--is-red": ticket.get("eliminated_by_race_number") === number
    })}>
      <li className="leaderboard_picks_cell leaderboard_picks_cell--race">
        {number}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--track">
        {race.get("track_abbreviation")}
        -

        {race.get("race_number")}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--pick">
        {pick}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--horse">
        {horse}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--odds">
        {odds}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--results">
        {position}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--rank">
        {rank}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--movement">
        {movement}
      </li>

      <li className="leaderboard_picks_cell leaderboard_picks_cell--score">
        {score}
      </li>
    </ul>
  );
});

function getPlace(lane, result) {
  if (result) {
    var first = result.get("first");
    if (first && first.indexOf(lane) !== -1) {
      return "1st";
    }
    var second = result.get("second");
    if (second && second.indexOf(lane) !== -1) {
      return "2nd";
    }
    var third = result.get("third");
    if (third && third.indexOf(lane) !== -1) {
      return "3rd";
    }
    var fourth = result.get("fourth");
    if (fourth && fourth.indexOf(lane) !== -1) {
      return "4th";
    }
  }
  return "";
}
